<template>
  <div class="mentions-legales content">
    <section id="page-title" class="page-title-mini">
			<div class="container clearfix">
				<h1>{{ $t('legal.mentions-legales.title') }}</h1>
			</div>
		</section>
    <div class="content-wrap">
      <div class="container clearfix">
        <Fragment path="mentions-legales"></Fragment>
      </div>
    </div>
  </div>
</template>

<style>

</style>

<script lang="ts">
import { Component } from '@fwk-node-modules/vue-property-decorator';
import { mixins } from '@fwk-node-modules/vue-class-component';
import { mapGetters } from '@fwk-node-modules/vuex';
import GenericPage from '@fwk-client/components/mixins/GenericPage.vue';
import { languagesTypes } from '@fwk-client/store/types';
import Fragment from '@fwk-client/components/panels/Fragment.vue';

@Component({
  components: {
	  Fragment
  },
  computed: {
	  ...mapGetters({
          currentLanguageCode : 'languages/' + languagesTypes.getters.GET_CURRENT_LANGUAGE
        }),
  }
})
export default class MentionsLegales extends mixins(GenericPage) {

	

}
</script>